import { BaseModel } from './base.model'
import { Moment } from 'moment'

export class OnlineLearningRegistrationData {
  centerId: number
  firstName?: string
  lastName?: string
  licenseNumber?: string
  driverLicense?: string
  middleName?: string
  phone?: string
  programId?: number
  tariffName?: string
  examPassed?: boolean
  mechanics?: string
  hubModerationId?: number
  hubModerationCourse?: string
  uuid?: string
  target?: string
  driverId?: string
  locale?: string
  country?: string
  driverCity: string
  scheduledAt?: string
  rating?: number
}

export class OnlineLearningRegistration extends BaseModel<OnlineLearningRegistration> {
  uuid: string
  data: OnlineLearningRegistrationData
  createdAt: Moment
  updatedAt: Moment
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-learning-registration.model.ts